import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Account Contacts</Typography>
      <p>As with your main account details, please ensure your contact data is kept
        up-to-date. This should be the main person we should contact in the event of an issue.
      </p>

      <p>We need to be able to send your invoice and contact you if there are payment difficulties. We
        will send emails when we raise invoices to your billing email. This can be the same as your
        main email or different.
      </p>

      <p>We will also contact you in the event that we experience system problems that effect your passes or
        if we identify problems with your template design.
      </p>
    </div>
  )
}

export default HelpText